import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { styled } from "@mui/material/styles";
import dayjs from "dayjs"; // Ensure dayjs is installed
const CustomDateCalendar = styled(DateCalendar)(({ theme }) => ({
  borderRadius: '13px', // Rounded corners
  boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', // Shadow
  backgroundColor: '#fff', // White background
  "& .MuiPickersCalendarHeader-label": {
    fontSize: "15px",
  },
  // Change selected date color
  "& .MuiPickersDay-root.Mui-selected": {
    backgroundColor: "#1D2951",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1D2951", // Keep same color on hover
    },
  },
}));



export default function BasicDateCalendar({ value, onDateChange }) {
  // If parent passes "value", use that. Otherwise use internal state.
  const isControlled = value !== undefined;

  const [internalDate, setInternalDate] = React.useState(dayjs());

  const currentValue = isControlled ? value : internalDate;

  const handleDateChange = (newDate) => {
    if (!isControlled) {
      setInternalDate(newDate); // Works like before
    }
    onDateChange && onDateChange(newDate); // Call parent if provided
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div>
        <CustomDateCalendar value={currentValue} onChange={handleDateChange} />
      </div>
    </LocalizationProvider>
  );
}

